import { render, staticRenderFns } from "./SelectTemplateBanner.vue?vue&type=template&id=3428e056"
import script from "./SelectTemplateBanner.vue?vue&type=script&lang=js"
export * from "./SelectTemplateBanner.vue?vue&type=script&lang=js"
import style0 from "./SelectTemplateBanner.vue?vue&type=style&index=0&id=3428e056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports